export default "__VITE_ASSET__7bf5c12d__"